import { createGlobalStyle } from 'styled-components'

// The global style gives `body` a white background, which Chrome prints as
// the page background; `html body` outranks that rule so a transparent print
// paints nothing behind the page.
export const TransparentPrintPage = createGlobalStyle`
  html,
  html body {
    background: transparent;
  }
`
